








import { Component, Vue } from 'vue-property-decorator';
const Timeline = require('vue-tweet-embed').Timeline;
import ConfigModlue from '@/store/modules/config';
import { Config } from '@/types/config';

// @link https://www.npmjs.com/package/vue-tweet-embed
// @link https://developer.twitter.com/en/docs/twitter-for-websites/timelines/overview
@Component({
  components: {
    Timeline
  }
})
export default class TweetTimeline extends Vue {
  // TwitterID
  private twitterId = ConfigModlue.twitterid;

  // requestAnimationFrame のエントリーID
  private requestID?: number;

  // タイマーID
  private timerID?: NodeJS.Timeout;

  // 自動スクロールをするときの位置
  private y = 0;

  // 表示するツイート数（1〜20件の間）
  private tweetLimit = 5;

  // スクロール時間（ミリ秒）
  private timeout = 60 * 1000;

  // スクロールスピード
  private speed = 1;

  // タイムライン表示のフラグ
  private isShow = false;

  $refs!: {
    timeline: InstanceType<typeof HTMLElement>;
    content: InstanceType<typeof HTMLElement>;
  };

  created() {
    const config: Config = Vue.prototype.$config;
    if (config !== undefined && config.tweetTimeline !== undefined) {
      if (config.tweetTimeline.tweetLimit !== undefined) {
        this.tweetLimit = config.tweetTimeline.tweetLimit;
      }
      if (config.tweetTimeline.timeout !== undefined) {
        this.timeout = config.tweetTimeline.timeout;
      }
      if (config.tweetTimeline.speed !== undefined) {
        this.speed = config.tweetTimeline.speed;
      }
    }
  }

  activated() {
    // 1秒後にTwitter表示
    this.timerID = setTimeout(() => {
      this.isShow = true;
      this.preload();
    }, 1000);
  }

  deactivated() {
    this.timerID && clearTimeout(this.timerID);
    this.requestID && cancelAnimationFrame(this.requestID);
    this.isShow = false;
  }

  /**
   * タイムライン領域確認中
   */
  private preload() {
    const rect = this.$refs.content.getBoundingClientRect();
    if (rect.height > 0) {
      this.timerID = setTimeout(() => {
        this.tick();
        this.timerID = setTimeout(this.reload.bind(this), this.timeout);
      }, 1000);
    } else {
      this.requestID = requestAnimationFrame(this.preload.bind(this));
    }
  }

  /**
   * リロード処理
   */
  private reload() {
    this.requestID && cancelAnimationFrame(this.requestID);
    this.isShow = false;
    this.$nextTick(() => {
      if (this.$refs.timeline) {
        this.y = 0;
        this.isShow = true;
        this.preload();
      }
    });
  }

  /**
   * 自動スクロール
   */
  private tick() {
    this.y += this.speed;
    this.$refs.timeline.scrollTop = this.y;
    this.requestID = requestAnimationFrame(this.tick.bind(this));
  }
}
